<script>

    import { createEventDispatcher } from "svelte";


    const dispatch = createEventDispatcher();

    export let id;
    export let icon;
    export let name;
    export let linkStatus = 'unlinked';
    export let linkText;
    export let data = false;
    export let title = false;
    export let subtitle = false;
    export let available = true;

    $: getTitle = () => {

        return (data['name']) ? data['name'] : '';
    };

    $: getSubtitle = () => {

        return (data['address']) ? data['address'] : '';
    };


    const onIntegrationClicked = () => {

        if (!available) return;

        dispatch('clicked', {
            id: id,
            status: linkStatus
        });

    };

</script>


<div on:click={() => onIntegrationClicked()} class="integration">

    <img src={icon} alt="Icon" />

    {#if available}

        {#if linkStatus === 'unlinked'}

            <div class="integration-text">

                <div class="integration-title">{linkText}</div>

            </div>

            <img src="/images/icons/arrow-default.svg" />

        {:else}

            <div class="integration-text">

                <div class="integration-title">{getTitle()}</div>

                {#if getSubtitle()}

                    <div class="integration-subtitle">{getSubtitle()}</div>

                {/if}

            </div>

            <img src="/images/icons/edit.svg" />

        {/if}

    {:else}

        <div class="integration-text">

            <div class="integration-title">{name + ' ist temporär nicht verfügbar'}</div>

        </div>

        <div class="placeholder-nothing"></div>

    {/if}

</div>


<style>

    .integration {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 27.8vh;
        padding: 1.3vh 1.64vh;
        border-radius: 1vh;
        cursor: pointer;
        background-color: #FFFFFF;
        -webkit-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.15);
        -moz-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.15);
        box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.15);
    }

    .integration-text {
        display: flex;
        flex-direction: column;
        width: 21.01vh;
        font-family: 'Raleway', sans-serif;
        text-align: left;
    }

    .integration-title {
        font-weight: 500;
        font-size: 1.29vh;
    }

    .integration-subtitle {
        font-weight: 300;
        font-size: 1.2vh;
    }

</style>
